import * as React from "react";
import { useNavigate } from "react-router-dom";

import About from "../../../assets/profile/about-us.svg";
import Contact from "../../../assets/profile/contact-us.svg";
import twitter from "../../../assets/svg/twitter.svg";
import instagram from "../../../assets/svg/instagram.svg";
import whatsapp from "../../../assets/svg/whatsapp.svg";
import { TemplateSub } from "../../../components/layouts/TemplateSub";

import * as ROUTES from "../../../constants/routes";

export const HelpPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <TemplateSub page="Help & Support">
      <div className="px-4">
        <div className="flex flex-col gap-[10px] mt-[1rem] w-full">
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.ABOUT_US)}
          >
            <img src={About} alt="" width={20} height={20} />
            <p className="text-[white] text-[16px] ">About Us</p>
          </button>

          <a
            href="mailto:contact@njoy.live"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[white] text-[16px] hover:text-white active:text-white focus:text-white focus:outline-none active:outline-none [tap-highlight-color:transparent]"
          >
            <button className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg">
              <img src={Contact} alt="" width={20} height={20} />
              Email
            </button>
          </a>
          <a
            href="https://api.whatsapp.com/send/?phone=2348077770930&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[white] text-[16px] hover:text-white active:text-white focus:text-white focus:outline-none active:outline-none [tap-highlight-color:transparent]"
          >
            <button className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg">
              <img src={whatsapp} alt="" width={20} height={20} />
              WhatsApp
            </button>
          </a>
          <a
            href="https://x.com/njoydotlive"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[white] text-[16px] hover:text-white active:text-white focus:text-white focus:outline-none active:outline-none [tap-highlight-color:transparent]"
          >
            <button className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg">
              <img src={twitter} alt="" width={20} height={20} />
              X (Twitter)
            </button>
          </a>
          <a
            href="https://www.instagram.com/njoydotlive"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[white] text-[16px] hover:text-white active:text-white focus:text-white focus:outline-none active:outline-none [tap-highlight-color:transparent]"
          >
            <button className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg">
              <img src={instagram} alt="" width={20} height={20} />
              Instagram
            </button>
          </a>
        </div>
      </div>
    </TemplateSub>
  );
};
